/**
 * Backend endpoints, baked in at build time by Vite.
 *
 * VITE_SERVER_URL — origin of the backend, used for Socket.IO and for
 *   server-hosted files under /uploads. Set it to an empty string to use the
 *   same origin the panel itself is served from, which is what the nginx
 *   reverse proxy does in the Docker image. Unset, it falls back to the local
 *   dev backend.
 *
 * VITE_API_URL — base URL for REST calls. Defaults to `${SERVER_URL}/api`, so
 *   you normally only need to set VITE_SERVER_URL.
 */
export const SERVER_URL = import.meta.env.VITE_SERVER_URL ?? 'http://localhost:3000'

export const API_URL = import.meta.env.VITE_API_URL ?? `${SERVER_URL}/api`

/** Resolves a server-relative asset path (e.g. `/uploads/logo.png`) to a full URL. */
export const assetUrl = (assetPath?: string | null): string | undefined =>
  assetPath ? `${SERVER_URL}${assetPath}` : undefined
